// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".characterization-survey-modal--dialog {\n  max-width: 80vw; }\n  .characterization-survey-modal--dialog .modal-content {\n    width: 80vw;\n    height: 90vh;\n    overflow-y: auto; }\n", ""]);
// Exports
module.exports = exports;
